import { useState } from "react";

export const useMapping = () => {
  const [mappings, setMappings] = useState([]);

  const addMapping = (mappingObj) => {
    const exists = mappings.find(
      (m) =>
        m.jiraId === mappingObj.jiraId ||
        m.templateId === mappingObj.templateId,
    );

    if (exists) return false;

    setMappings((prev) => [...prev, mappingObj]);
    return true;
  };

  const removeMapping = (rowId) => {
    setMappings((prev) => prev.filter((m) => m.rowId !== rowId));
  };

  return {
    mappings,
    addMapping,
    removeMapping,
    setMappings,
  };
};
